import * as React from "react";

import { cn } from "@/lib/utils";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex min-h-[18px] max-h-[150px] w-full rounded-sm border border-input placeholder:text-border bg-white p-[10px] text-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-info-muted disabled:cursor-not-allowed disabled:opacity-50 max-w-full",
          className
        )}
        style={{
          // @ts-expect-error css property exists
          fieldSizing: "content",
          resize: "none",
        }}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = "Textarea";

export { Textarea };
